import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["assetIds", "enabled"],
  _excluded2 = ["data"];
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useQuery } from '@tanstack/react-query';
import { assetQueryKeys } from 'actions/assets';
import api from 'utils/api';
import groupBy from 'utils/groupBy';
import isAdmin from 'utils/session/isAdmin';
function calculateAssetSharingPermissions(_x, _x2) {
  return _calculateAssetSharingPermissions.apply(this, arguments);
}
function _calculateAssetSharingPermissions() {
  _calculateAssetSharingPermissions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(contents, assetIds) {
    var playlistsGroupedByAsset, contentPermissions, assetId, items, permission, overallContentAudienceType;
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          playlistsGroupedByAsset = groupBy(contents, function (c) {
            return c.asset_id;
          });
          contentPermissions = [];
          if (!(contents.length === 0 || assetIds.length !== Object.keys(playlistsGroupedByAsset).length)) {
            _context2.next = 1;
            break;
          }
          return _context2.abrupt("return", {
            contentPermissions: [],
            overallContentAudienceType: 'admin'
          });
        case 1:
          for (assetId in playlistsGroupedByAsset) {
            items = playlistsGroupedByAsset[assetId];
            permission = {
              id: assetId,
              name: items === null || items === void 0 ? void 0 : items[0].asset_name
            };
            if (items !== null && items !== void 0 && items.every(function (c) {
              return c.audience === 'admin';
            })) {
              permission.audienceType = 'admin';
              permission.teamIds = [];
            } else if (items !== null && items !== void 0 && items.some(function (c) {
              return c.audience === 'all';
            })) {
              permission.audienceType = 'all';
              permission.teamIds = [];
            } else {
              permission.audienceType = 'teams';
              permission.teamIds = (items === null || items === void 0 ? void 0 : items.map(function (c) {
                return c.contentTeams.map(function (t) {
                  return t.team_id;
                });
              }).flat()) || [];
            }
            contentPermissions.push(permission);
          }
          overallContentAudienceType = 'teams';
          if (contentPermissions.some(function (permission) {
            return permission.audienceType === 'admin';
          })) {
            overallContentAudienceType = 'admin';
          } else if (contentPermissions.every(function (permission) {
            return permission.audienceType === 'all';
          })) {
            overallContentAudienceType = 'all';
          }
          return _context2.abrupt("return", {
            contentPermissions: contentPermissions,
            overallContentAudienceType: overallContentAudienceType
          });
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _calculateAssetSharingPermissions.apply(this, arguments);
}
function fetchAssetSharePermissions(_x3) {
  return _fetchAssetSharePermissions.apply(this, arguments);
}
function _fetchAssetSharePermissions() {
  _fetchAssetSharePermissions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(assetIds) {
    var res;
    return _regeneratorRuntime.wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 1;
          return api('get', '/api/query/playlist', {
            fields: ['id', {
              asset_id: 'assetCollections.asset_id',
              asset_name: 'assetCollections.commonAsset.name',
              audience: 'assetDomains.audience_calculated',
              contentTeams: ['team_id']
            }],
            join: {
              contentTeams: {
                is_calculated: true
              }
            },
            filter: {
              'assetCollections.asset_id': assetIds
            },
            groupby: 'assetCollections.id',
            orderby: ['assetCollections.commonAsset.name'],
            limit: 1000
          });
        case 1:
          res = _context3.sent;
          return _context3.abrupt("return", calculateAssetSharingPermissions(res.items, assetIds));
        case 2:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _fetchAssetSharePermissions.apply(this, arguments);
}
export function useFetchAssetSharePermissions(_ref) {
  var assetIds = _ref.assetIds,
    enabled = _ref.enabled,
    queryOptions = _objectWithoutProperties(_ref, _excluded);
  function fetchContentSharePermissions(_x4) {
    return _fetchContentSharePermissions.apply(this, arguments);
  }
  function _fetchContentSharePermissions() {
    _fetchContentSharePermissions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(assetIds) {
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (assetIds) {
              _context.next = 1;
              break;
            }
            return _context.abrupt("return", {
              contentPermissions: [],
              overallContentAudienceType: 'admin'
            });
          case 1:
            return _context.abrupt("return", fetchAssetSharePermissions(assetIds));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _fetchContentSharePermissions.apply(this, arguments);
  }
  var _useQuery = useQuery(_objectSpread(_objectSpread({
      queryKey: assetQueryKeys.assetSharePermissions(assetIds),
      queryFn: function queryFn() {
        return fetchContentSharePermissions(assetIds);
      }
    }, queryOptions), {}, {
      enabled: enabled !== undefined ? enabled && isAdmin() && Boolean(assetIds === null || assetIds === void 0 ? void 0 : assetIds.length) : isAdmin() && Boolean(assetIds === null || assetIds === void 0 ? void 0 : assetIds.length)
    })),
    data = _useQuery.data,
    result = _objectWithoutProperties(_useQuery, _excluded2);
  return _objectSpread({
    data: data
  }, result);
}